import React from 'react';

const RefundCancellation = () => {
  const effectiveDate = 'February 2026';
  return (
    <main className="bg-white">
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-light text-charcoal-900 mb-6">
            Refund & Cancellation Policy
          </h1>
          <p className="text-charcoal-600 mb-2">Effective Date: {effectiveDate}</p>
          <p className="text-charcoal-700 leading-relaxed mb-8">
            We want you to have a positive experience with Alera. Please review our policy below.
          </p>

          <div className="space-y-10">
            <section>
              <h2 className="text-2xl font-semibold text-charcoal-900 mb-3">Subscriptions & Cancellation</h2>
              <ul className="list-disc pl-6 space-y-2 text-charcoal-700">
                <li>Alera subscriptions (Freedom plan) are available as monthly or annual billing options.</li>
                <li>Subscriptions renew automatically unless canceled before the renewal date.</li>
                <li>You may cancel your subscription at any time by contacting us at <a className="text-sage-700 underline hover:text-sage-800" href="mailto:hello@alera.co.nz">hello@alera.co.nz</a>.</li>
                <li><strong>Monthly Memberships:</strong> If you cancel a monthly subscription, your access remains active until the end of your current billing period. No further charges will occur.</li>
                <li><strong>Annual Memberships:</strong> Annual memberships are non-refundable. If you cancel before your year is complete, your access will continue until the end of your annual term, but you will not receive a refund for any remaining unused months. Your membership will not renew for the next annual cycle.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-charcoal-900 mb-3">Refunds</h2>
              <ul className="list-disc pl-6 space-y-2 text-charcoal-700">
                <li>Due to the digital nature of our products and services, all sales are final. We do not offer refunds for subscriptions, digital downloads, or recipe books once they have been accessed.</li>
                <li>If you believe there has been an error in billing, please contact us at <a className="text-sage-700 underline hover:text-sage-800" href="mailto:hello@alera.co.nz">hello@alera.co.nz</a> within 7 days.</li>
              </ul>
            </section>

            <section className="border-t border-sage-100 pt-6">
              <p className="text-charcoal-700">
                By purchasing a subscription or digital product, you agree to this policy.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default RefundCancellation;
